import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';
import { getRiver, getRiverData } from '../api/Rivers.js';
import River from './River.jsx';
import RiverMap from './RiverMap.jsx';
import ErrorPage from '../components/ErrorPage.jsx';

import 'mapbox-gl/dist/mapbox-gl.css';
import { ErrorBoundary } from '@sentry/react';

const REFETCH_INTERVAL = 900000;

function RiverPage({mapOnly = false}) {
  const { riverKey } = useParams();

  const riverQuery = useQuery({
    queryKey: ['rivers', riverKey],
    queryFn: getRiver.bind(this, riverKey),
    refetchInterval: false,
  });

  const dataQuery = useQuery({
    queryKey: ['rivers', riverKey, 'data'],
    queryFn: getRiverData.bind(this, riverKey),
    refetchInterval: REFETCH_INTERVAL,
  });

  return (
    <ErrorBoundary fallback={ErrorPage}>
      {riverQuery.isError && <ErrorPage error={riverQuery.error} />}
      {!riverQuery.isError && dataQuery.isError && <ErrorPage error={dataQuery.error} />}
      {!riverQuery.isError && !dataQuery.isError && !mapOnly && <River river={riverQuery.data} allData={dataQuery.data} />}
      {!riverQuery.isError && !dataQuery.isError && mapOnly && <RiverMap river={riverQuery.data} allData={dataQuery.data} />}
    </ErrorBoundary>
  );
}

export default RiverPage
